import SampleColorCard from "../components/Card/SampleColorCard";
import Restricted from "../context/Restricted";
import {Link, useNavigate} from "react-router-dom";

export default function Dashboard() {
    const navigate = useNavigate();
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <h6 className="mt-2 fw-normal text-success">داشبورد</h6>
                    <hr className="mt-0"/>
                    <div className="row gy-4" >
                        <Restricted to="UserCategoryActiveUserCategoryList">
                                <SampleColorCard name={"دریافت شماره"} colorClass={"bg-warning"} publicClass={'fix-height'} click={()=>navigate("/marketer/user-category/list?page=1&pageSize=20")}></SampleColorCard>
                        </Restricted>
                        <Restricted to="UserUserItem">
                            <SampleColorCard name={"لیست کاربران"} colorClass={"bg-primary"} publicClass={'fix-height'} click={()=>navigate("/user/list?page=1&pageSize=20")}></SampleColorCard>
                        </Restricted>
                        <Restricted to="SampleCardSampleCardList">
                            <SampleColorCard name={"ایجاد کارت"} colorClass={"bg-secondary"} publicClass={'fix-height'} click={()=>navigate("/sample-card/list?page=1&pageSize=20")}></SampleColorCard>
                        </Restricted>
                        <Restricted to="FollowUpUserUserFollowUpList">
                            <SampleColorCard name={"لیست شخصی"} colorClass={"bg-success"} publicClass={'fix-height'} click={()=>navigate("/marketer/user-followup-personal/list?type=0&page=1&pageSize=20")}></SampleColorCard>
                        </Restricted>
                        <Restricted to="FollowUpUserUserFollowUpList">
                            <SampleColorCard name={"لیست پیگیری"} colorClass={"bg-danger"} publicClass={'fix-height'} click={()=>navigate("/marketer/user-followup/list?page=1&pageSize=20&type=1")}></SampleColorCard>
                        </Restricted>
                        <Restricted to="UserReportUserActivityReport">
                            <SampleColorCard name={"فعالیت بازاریاب ها"} colorClass={"bg-info"} publicClass={'fix-height'} click={()=>navigate("/report/user-activity?page=1&pageSize=20&type=1")}></SampleColorCard>
                        </Restricted>
                        <Restricted to="UserReportCallStatusBlockList">
                            <SampleColorCard name={"بلاک شده ها"} colorClass={"bg-info"} publicClass={'fix-height'} click={()=>navigate("/report/user-block?page=1&pageSize=20&type=1")}></SampleColorCard>
                        </Restricted>
                    </div>
                </div>
            </div>
        </>
    )
}